import { Clickable } from '@carvana/merch-components';
import { useContext } from 'react';
import { getPurchaseStatus } from '@/SearchResults/ResultTile/ResultTile.helpers';
import Tag from '@/SearchResults/ResultTile/Tags/Tag';
import useSendOpenModalEvent, {
  OpenSource
} from '@/SearchResults/ResultTileV2/useSendOpenModalEvent';
import MoreDetailsModalSections from '~/constants/MoreDetailsModalSections';
import ModalContext from '~/contexts/ModalContext';
import { useVehicleContext } from '~/contexts/VehicleContext';
import { Vehicle } from '~/contracts';
import { VehicleTag } from '~/contracts/Vehicle';

const findGreatDeal = (tag: VehicleTag) => tag?.tagId === 104;

export const useGreatDealTag = (
  vehicle: Partial<Vehicle>
): VehicleTag | null => {
  return vehicle?.vehicleTags?.find(findGreatDeal) ?? null;
};

const GreatDealTag = () => {
  const { vehicle } = useVehicleContext();
  const { setMoreDetailsModalOpen } = useContext(ModalContext);
  const sendOpenEvent = useSendOpenModalEvent();

  const { isLocked, isOnHold } = getPurchaseStatus(vehicle);
  const greatDeal = useGreatDealTag(vehicle);

  if (
    isLocked ||
    isOnHold ||
    vehicle?.vehiclePurchaseType === 'Reservable' ||
    greatDeal == null
  ) {
    return null;
  }

  return (
    <Clickable
      data-analytics-id={null}
      className="pointer-events-auto"
      data-qa="great-deal-badge"
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        sendOpenEvent(OpenSource.GreatDeal);
        setMoreDetailsModalOpen(true, {
          openTo: MoreDetailsModalSections.GreatDeal,
          vehicleId: vehicle.vehicleId
        });
      }}
    >
      <Tag text={greatDeal.tagName} bgColor="bg-blue-4" />
    </Clickable>
  );
};

export default GreatDealTag;
